export default "__VITE_ASSET__C0xpQh0o__"